import { handleActions } from 'redux-actions';
import { deepFreeze } from '@mw/helpers';

import {
  setDocumentViewModal,
  setImageGalleryModal,
  setImageViewModal,
  setShortLinksModal,
  setWATemplatesModal,
} from '~/actions/modals';

import { ModalTypes } from '~/constants';

const viewModalDefaultState = deepFreeze({
  isOpen: false,
  src: null,
});

const defaultModalDefaultState = deepFreeze({
  isOpen: false,
});

const initialState = {
  [ModalTypes.IMAGE]: viewModalDefaultState,
  [ModalTypes.DOCUMENT]: viewModalDefaultState,
  [ModalTypes.WA_TEMPLATES]: defaultModalDefaultState,
  [ModalTypes.IMAGE_GALLERY]: { isOpen: false, ref: null },
  [ModalTypes.SHORT_LINKS]: defaultModalDefaultState,
};

const setDefaultModal =
  (type) =>
  (state, { payload: { isOpen } }) => ({
    ...state,
    [type]: {
      isOpen,
    },
  });

const setViewModal =
  (type) =>
  (state, { payload: { isOpen, src } }) => ({
    ...state,
    [type]: {
      isOpen,
      src,
    },
  });

const modalReducer = handleActions(
  {
    [setImageViewModal]: setViewModal(ModalTypes.IMAGE),
    [setDocumentViewModal]: setViewModal(ModalTypes.DOCUMENT),
    [setWATemplatesModal]: setDefaultModal(ModalTypes.WA_TEMPLATES),
    [setImageGalleryModal]: (state, { payload: { isOpen, ref } }) => {
      const prevModalState = state[ModalTypes.IMAGE_GALLERY];

      return {
        ...state,
        [ModalTypes.IMAGE_GALLERY]: {
          isOpen: isOpen ?? prevModalState.isOpen,
          ref: ref ?? prevModalState.ref,
        },
      };
    },
    [setShortLinksModal]: setDefaultModal(ModalTypes.SHORT_LINKS),
  },
  initialState
);

export { modalReducer };
